import { render, staticRenderFns } from "./questionPaper.vue?vue&type=template&id=c2e1875e&scoped=true&"
import script from "./questionPaper.vue?vue&type=script&lang=js&"
export * from "./questionPaper.vue?vue&type=script&lang=js&"
import style0 from "./questionPaper.vue?vue&type=style&index=0&id=c2e1875e&lang=scss&scoped=true&"
import style1 from "./questionPaper.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./questionPaper.vue?vue&type=style&index=2&id=c2e1875e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e1875e",
  null
  
)

export default component.exports